export default "__VITE_ASSET__DZHSejA6__"